export function isEmpty(value: string) {
  return value === null || value === undefined || value?.length === 0;
}

export function isValidateEmail(value: string) {
  const re = /\S+@\S+\.\S+/;
  return re.test(value);
}

export function isValidatePhoneLength(val: string) {
  return val?.length >= 1 && val?.length < 14;
}

export function isNumberOnly(val: string) {
  return val.replace(/[^0-9]+/gi, '');
}

export function isValidateCodeLength(val: string) {
  return val?.length >= 1 && val?.length < 8;
}
export function formatPhoneNumber(value: string) {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, '');
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6,
  )}-${phoneNumber.slice(6, 10)}`;
}
export function formatConfirmationCode(value: string) {
  if (!value) return value;
  const confirmationCode = value.replace(/[^\d]/g, '');
  return confirmationCode;
}
